import { SocietyUserVar } from "@dune/types";
import {
	Button,
	Dialog,
	DialogContent,
	DialogDescription,
	DialogFooter,
	DialogHeader,
	DialogTitle,
	RootDialogProps,
} from "@dune/ui";
import { useUpdateUser } from "../../../../../../api/mutations/user.mutations";

interface SuspendUserDialogProps extends RootDialogProps {
	user: SocietyUserVar;
}

export const SuspendUserDialog = ({
	user,
	...props
}: SuspendUserDialogProps) => {
	const { mutate, isPending } = useUpdateUser(user.societyId || 0);

	if (!user.societyId) {
		return null;
	}

	const handleSuspend = () => {
		mutate(
			{
				user: {
					id: user.id,
					email: user.email,
					firstname: user.firstname,
					lastname: user.lastname,
					subrole: user.subrole,
					positionInTheCompany: user.positionInTheCompany,
					mobilePhone: user.mobilePhone,
					landlinePhone: user.landlinePhone,
					isActive: !user.isActive,
				},
			},
			{
				onSuccess: () => {
					props.onOpenChange?.(false);
				},
			},
		);
	};

	return (
		<Dialog {...props}>
			<DialogContent>
				<DialogHeader>
					<DialogTitle>
						{user.isActive ? "Suspendre" : "Réactiver"} l'utilisateur
					</DialogTitle>
					<DialogDescription>
						Êtes-vous sûr de vouloir {user.isActive ? "suspendre" : "réactiver"}{" "}
						l'utilisateur {user.firstname} {user.lastname} ?
					</DialogDescription>
				</DialogHeader>

				<DialogFooter>
					<Button
						type="button"
						variant="outline"
						onClick={() => props.onOpenChange?.(false)}
					>
						Annuler
					</Button>
					<Button
						type="button"
						variant={user.isActive ? "destructive" : "default"}
						isLoading={isPending}
						onClick={handleSuspend}
					>
						{user.isActive ? "Suspendre" : "Réactiver"}
					</Button>
				</DialogFooter>
			</DialogContent>
		</Dialog>
	);
};
